import { privateRequest, publicRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    LEAD_MAGNET_FORMS: "api/LeadMagnetForms",
    EMBED_CODE: "api/LeadMagnetForms/embed-code",
    EMBED: "api/LeadMagnetForms/Embed",
    LEAD_FORMS_SUBMISSIONS: "api/LeadsForm/submissions",
    SUBMIT_FORM: "api/LeadsForm/embed/submit",
}

export const getLeadForms = async (params: any): Promise<ApiResponse<any[]>> => {
    const res = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.LEAD_MAGNET_FORMS, { params: params });
    return res.data;
};

export const getLeadFormDetails = async (params: { formCode: string }): Promise<ApiResponse<any[]>> => {
    const res = await privateRequest.get<ApiResponse<any[]>>(`${ENDPOINTS.LEAD_MAGNET_FORMS}/details`, { params: params });
    return res.data;
};

export const getAllFieldMasters = async (): Promise<ApiResponse<any[]>> => {
    const res = await privateRequest.get<ApiResponse<any[]>>(`${ENDPOINTS.LEAD_MAGNET_FORMS}/field-masters`);
    return res.data;
};

export const addLeadForm = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.LEAD_MAGNET_FORMS, payload);
    return res.data;
};

export const updateLeadForm = async (updatedPayload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.put<ApiResponse<any>>(`${ENDPOINTS.LEAD_MAGNET_FORMS}/lead-form`, updatedPayload);
    return res.data;
};

export const getLeadSubmittedForm = async (params: any): Promise<ApiResponse<any[]>> => {
    const res = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.LEAD_FORMS_SUBMISSIONS, { params: params });
    return res.data;
};

export const getLeadSubmittedFormById = async (submissionId: string): Promise<ApiResponse<any[]>> => {
    const res = await privateRequest.get<ApiResponse<any[]>>(`${ENDPOINTS.LEAD_FORMS_SUBMISSIONS}/${submissionId}`);
    return res.data;
};

export const addSubmitForm = async (payload: any, parentOrigin: string): Promise<ApiResponse<any>> => {
    const res = await publicRequest.post<ApiResponse<any>>(
        ENDPOINTS.SUBMIT_FORM,
        payload,
        {
            headers: {
                "X-Parent-Origin": parentOrigin,
            },
        }
    );
    return res.data;
};

export const getEmbedCode = async (formCode: string): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(`${ENDPOINTS.EMBED_CODE}?formCode=${formCode}`);
    return res.data;
};

export const getEmbed = async (formCode: string, parentOrigin: string): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get<ApiResponse<any>>(
        `${ENDPOINTS.EMBED}/${formCode}`,
        {
            headers: {
                "X-Parent-Origin": parentOrigin,
            },
        }
    );
    return res.data;
};

export const updateRequestStatus = async (updatedPayload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.put<ApiResponse<any>>(`${ENDPOINTS.LEAD_FORMS_SUBMISSIONS}/status`, updatedPayload);
    return res.data;
};

export const updatePublishFormStatus = async (updatedPayload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.put<ApiResponse<any>>(`${ENDPOINTS.LEAD_FORMS_SUBMISSIONS}/publish-status`, updatedPayload);
    return res.data;
};

const LeadCaptureService = {
    getLeadForms,
    getLeadFormDetails,
    getAllFieldMasters,
    addLeadForm,
    updateLeadForm,
    getLeadSubmittedForm,
    getLeadSubmittedFormById,
    addSubmitForm,
    getEmbedCode,
    getEmbed,
    updateRequestStatus,
    updatePublishFormStatus,
};

export default LeadCaptureService;